import { render, staticRenderFns } from "./LatestSales.vue?vue&type=template&id=427a5c1b&"
import script from "./LatestSales.vue?vue&type=script&lang=js&"
export * from "./LatestSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports